import { OperatorModel } from "./operator.model";
export class userDetailsModel {
    username?:string;
    logints?:string;
    ipaddr?:string;
    ua?:string;
   }
   